import React from 'react';
import { useLocation } from 'react-router-dom';

import classNames from 'classnames';

import { AUTH_FOOTER, SIGNUP_PATHS } from '../../constants';

import Alert from './alert';
import AuthBanner from './auth-banner';

import './authorization.scss';

const Authorization: React.FC = ({ children }) => {
  const location = useLocation();

  return (
    <div
      className={classNames('authorization', {
        'authorization--contract':
          location.pathname === SIGNUP_PATHS.AGREEMENT ||
          location.pathname === SIGNUP_PATHS.KEY_GENERATION ||
          location.pathname === SIGNUP_PATHS.KEY_GENERATION_RESULT ||
          location.pathname === '/restore-key',
        'authorization--donload-doc': location.pathname === SIGNUP_PATHS.DOCS,
        'authorization--pick-password':
          location.pathname === SIGNUP_PATHS.PASSWORD,
      })}
    >
      <div className="authorization__left">
        <div className="authorization__wraper">
          <div className="authorization__body">
            <div className="authorization__content">
              <div className="authorization__logo">
                <a className="logo" href="/">
                  <svg
                    className="logo__icon"
                    width="215"
                    height="187"
                    viewBox="0 0 215 187"
                    fill="none"
                  >
                    <path
                      d="M195.22 31.23C176.25 10.34 148.54 0 107.32 0C66.09 0 39.26 10.56 19.42 33.06C5.89 48.46 0 68.2 0 92.77C0 120.09 7.42 140.76 21.16 155.92C39.04 175.66 67.4 186.69 107.32 186.69C148.11 186.69 178.21 176.12 195 155.46C207.65 140.31 214.63 119.87 214.63 92.78C214.64 66.59 209.18 46.84 195.22 31.23Z"
                      fill="url(#logo)"
                    />
                    <path
                      d="M158.71 59.39C159.58 59.39 160.44 59.32 161.28 59.22C171.74 57.95 179.85 49.05 179.85 38.25H158.71H107.32C82.98 38.25 67.15 44.48 55.44 57.76C47.45 66.84 43.98 78.5 43.98 93C43.98 109.13 48.36 121.32 56.47 130.27C67.03 141.92 83.76 148.43 107.33 148.43C131.41 148.43 149.17 142.19 159.08 129.99C166.51 121.08 170.63 109.08 170.67 93.19C170.63 64.5 141.6 59.97 131.19 59.38L137.19 59.37H158.71V59.39ZM145.94 93.41C145.94 102.63 144.01 111.57 138.86 116.86C132.04 123.91 122.89 127.57 107.32 127.57C93.03 127.57 84.27 124.32 77.32 118.08C71.14 112.52 68.83 103.71 68.83 93.41C68.83 83.92 71.28 75.38 75.78 70.23C81.7 63.73 91.74 59.39 107.19 59.39C123.41 59.39 132.04 63.32 138.99 69.96C144.01 74.85 145.94 84.06 145.94 93.41Z"
                      fill="white"
                    />
                    <defs>
                      <linearGradient
                        id="logo"
                        x1="0"
                        y1="93.3462"
                        x2="214.635"
                        y2="93.3462"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#0059F7" />
                        <stop offset="1" stopColor="#0021D8" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <p className="p p_font-size_12 p_color_blue">
                    ЦИФРОВЫЕ <br /> ФИНАНСОВЫЕ АКТИВЫ
                  </p>
                </a>
              </div>
              {children}
              <Alert />
            </div>
            <div className="authorization__footer">
              <p className="text-3">{AUTH_FOOTER}</p>
            </div>
          </div>
        </div>
      </div>
      <AuthBanner locationPath={location.pathname} />
    </div>
  );
};

export default Authorization;
